import { render, staticRenderFns } from "./DamagedMoneyStatus.vue?vue&type=template&id=6170beb3&scoped=true&"
import script from "./DamagedMoneyStatus.vue?vue&type=script&lang=js&"
export * from "./DamagedMoneyStatus.vue?vue&type=script&lang=js&"
import style0 from "./DamagedMoneyStatus.vue?vue&type=style&index=0&id=6170beb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6170beb3",
  null
  
)

export default component.exports